import { ActionReducerMap } from '@ngrx/store';
import * as auth from './auth/auth.reducer';
import * as common from './common/common.reducer';
import { assistenceValueReducer } from './multi_product/stores/assistenceValue.reducer';
import { coinReducer } from './multi_product/stores/coin.reducer';
import { comisionReducer } from './multi_product/stores/comision.reducer';
import { intermediaryRelatedReducer } from './multi_product/stores/intermediaryRelated.reducer';
import { premiumTotalValueReducer } from './multi_product/stores/premiumTotalValue.reducer';
import { premiumValueReducer } from './multi_product/stores/premiumValue.reducer';
import { quotesReducer } from './multi_product/stores/quote.reducer';
import { taxReducer } from './multi_product/stores/tax.reducer';
import { totalPremiumDifferenceReducer } from './multi_product/stores/totalPremiumDifference.reducer';
import { totalsValueCoverageReducer } from './multi_product/stores/totalsValueCoverage.reducer';
import { withIOFReducer } from './multi_product/stores/withIOF.reducer';
import { pricesReducer } from './quote/stores/prices.reducer';
import { proposalReducer } from './quote/stores/proposal.reducer';
import { quoteReducer } from './quote/stores/quote.reducer';
import * as wizard from './quote/stores/wizard.reducer';
import { referenceInputsReducer } from './multi_product/stores/referenceInputs.reducer';
import { changeDateInitVigEndosoReducer } from './multi_product/stores/changeDateInitVigEndoso.reducer';
import { autonomyReducer } from './multi_product/stores/autonomy.reducer';
import * as afterQuotation from './multi_product/stores/afterQuotation.reducer';
import { isuredMattersValuesReducer } from './multi_product/stores/insuredMattersValues.reducer';

export interface AppState {
  quote: any;
  proposal: any;
  quotePrices: any;
  brokerSessionInfo: any;
  viewToast: common.State;
  wizard: wizard.State;
  premiumValue: number;
  coin: string;
  tax: number;
  comision: number;
  quotes: number;
  relatedIntermediary: boolean;
  totalsValueCoverage: any;
  premiumTotalValue: number;
  withIOF: boolean;
  assistenceValue: number;
  totalPremiumDifference: number;
  referenceInputs: any;
  changeDateInitVigEndoso: boolean;
  autonomy: string;
  afterQuotation: afterQuotation.State;
  isuredMattersValues: {
    predioValue: number;
    conteudoValue: number;
    lucroValue: number;
    predioConteudo: number;
    source: string;
  };
}

export const appReducers: ActionReducerMap<AppState> = {
  quote: quoteReducer,
  proposal: proposalReducer,
  quotePrices: pricesReducer,
  brokerSessionInfo: auth.brokerSessionInfoReducer,
  viewToast: common.commonReducer,
  wizard: wizard.wizardReducer,
  premiumValue: premiumValueReducer,
  coin: coinReducer,
  tax: taxReducer,
  comision: comisionReducer,
  quotes: quotesReducer,
  relatedIntermediary: intermediaryRelatedReducer,
  totalsValueCoverage: totalsValueCoverageReducer,
  premiumTotalValue: premiumTotalValueReducer,
  withIOF: withIOFReducer,
  assistenceValue: assistenceValueReducer,
  totalPremiumDifference: totalPremiumDifferenceReducer,
  referenceInputs: referenceInputsReducer,
  changeDateInitVigEndoso: changeDateInitVigEndosoReducer,
  autonomy: autonomyReducer,
  afterQuotation: afterQuotation.afterQuotationReducer,
  isuredMattersValues: isuredMattersValuesReducer,
};
